import { SupplyItemModel } from "./supply-item.model";

export class SupplyModel {
    public supplyId: string;
    public quantity: number;
    public supply: SupplyItemModel;
}